import { FileModel } from 'app/claims/claims-commons/models/file.model';
import { DriverModel } from 'app/claims/claims-commons/models/driver.model';
import { ImpactPointModel } from 'app/claims/claims-commons/models/impact-point.model';
import { CounterpartyCompany, Company } from 'app/claims/claims-commons/models/insurance-company.model';
import { InsuredModel } from 'app/claims/claims-commons/models/insured.model';
import { VehicleModel } from 'app/claims/claims-commons/models/vehicle.model';
import { PlaceRepair } from 'app/claims/claims-commons/models/appointment-repair.model';
import { EsbCounterpartResponse } from 'app/claims/claims-commons/models/esb-data-for-counterpart.model';
import { AssignedTo, Canalization, Historical, Lastcontact, ManagerRepair, ProcedureRepair, CounterpartStatus, ManagementType } from 'app/claims/claims-commons/models/counterparty.model';
import { Utilities } from '@shared/utilities/utilities.model';

export class RepairWorkingModel {

	id?: string;
	practice_id?: AssignedTo;
	created_at?: Date;
	claim_practice_id?: Canalization;
	status?: string;
	authority_practice_linked: string[];
	impact_point: ImpactPointModel;
	

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.practice_id = model.practice_id;
			this.created_at = model.created_at;
			this.claim_practice_id = model.claim_practice_id;
			this.status = model.status;
			this.authority_practice_linked = model.authority_practice_linked;
		}
	}

}
